import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Fee() { 
  useEffect(() => {
    document.title = 'Fee -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Rules</li>
                <li>Fee</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Fee</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
               <ul className="mainlist">
                    <li> Fees must be paid before/till due date in ICICI Bank preferably Govind Nagar, Kidwai Nagar branch. But can be deposited at any branch through out India.</li>
                    <li> Fees can also be paid through school website by logging into your account.</li>
                    <li> After due date fee paid will attract fine of Rs. 50 for per 15 days.</li>
                    <li> If the fees are not paid for two consecutive period, In such case School reserve the right to struck off the name from School register. In such cases re-admission may be done by charging full admission fee.</li>
                    <li> No exemption or deduction in fees will be made on account of broken periods, holidays or absence for any cause.</li>
                    <li> In April the fees of April and May will be deposited within three days after getting New Fee Book for the session. If not done so, the name of the students will not be included in the attendance register of July.</li>
                    <li> Fees in cash/cheque will be accepted in ICICI bank Branches, on all working days during banking hours.</li>
                    <li> No student will be allowed to appear for the examination and report card will not be given unless all dues have been cleared.</li>
                    <li> If Fee book is lost new fee book can be obtained from fee office by paying Rs. 100 along with written application.</li>
               </ul> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Fee;
